import { Component, OnInit } from '@angular/core';
import { PopoverController,Platform } from "@ionic/angular";
import { Router,NavigationExtras} from '@angular/router';
import { ApiService } from '../../services/api.service';
import { Storage } from '@ionic/storage';
import { NavParams} from '@ionic/angular';

@Component({
  selector: 'app-mypop',
  templateUrl: './mypop.component.html',
  styleUrls: ['./mypop.component.scss'],
})
export class MypopComponent implements OnInit {
  userprofile:any=[];
  administrator:boolean=false;
  dashboard:boolean;
  sanction: boolean;
  validate: boolean;
  approve: boolean;
  examine: boolean;
  processing:boolean;
  priveledge_list: any[];
  allow_dashboard: boolean;
  allow_performance: boolean;
  allow_usermanager: boolean;
  allow_unitBudget: boolean;
  constructor(private popover: PopoverController,
    private authService: ApiService,
    private apiService: ApiService,
    private storage: Storage,
    public navParams : NavParams,
    private plt: Platform,
    private router:Router) 
    {
      //Constructor
      this.dashboard=this.navParams.get('dashboard');
   }
//  close Popover
  ClosePopover() {
  this.popover.dismiss();
}
  ngOnInit() {
    this.plt.ready().then(() => {
      //load StockData after platform is ready
      this.storage.get('USER_INFO').then ((response) =>{
        console.log('local User',response.mak_webmail);
        this.userprofile = response;
         this.load_priveledges();
      });
    
    });
  }
// load Admin Staff list 
load_priveledges(refresh = false, refresher?) {
  let queryParams = {
    webmail:this.userprofile.mak_webmail
  }
  this.processing=true;
  let url =  `https://sso.mak.ac.ug/ravis/get_priveledges.php`;;
  this.apiService.addRecord(url,queryParams).subscribe(res => {
    this.priveledge_list = res.data;
    
  console.log('Rolesss',res.data)
   this.sanction=this.roleExists('sanction');
   this.validate=this.roleExists('validate');
   this.approve=this.roleExists('approve');
   this.examine=this.roleExists('examine');
   this.allow_dashboard =this.roleExists('dashboard');
   this.allow_performance =this.roleExists('performance');
   this.allow_usermanager =this.roleExists('usermanager');
   this.allow_unitBudget =this.roleExists('unit_budget');
   this.processing=false;
  });

}
// check if User 
roleExists(role ) {
  return this.priveledge_list.some(function(el) {
    return el.role === role;
    
  }); 
}
  // Navigate to account
    go_administration(){  
      this.popover.dismiss();
      this.router.navigate(['/dashboard']);
    }
    
     // Navigate to reports
    go_reports(){  
      this.popover.dismiss();
      this.router.navigate(['/reports']);
    }
    //  Nav completenes
nav_sanction_list(){ 
  this.popover.dismiss();
  this.router.navigate(['/sanction-list']);
}
//  Nav completenes
nav_completeness(){ 
  this.popover.dismiss();
  this.router.navigate(['/dash-completeness']);
}

//  Nav completenes
nav_approve(){ 
  this.popover.dismiss();
  this.router.navigate(['/approve-list']);
}
//  Nav examine
nav_examine(){ 
  this.popover.dismiss();
  this.router.navigate(['/list-examine']);
}
//  Nav examine
nav_perfomance(){ 
  this.popover.dismiss();
  this.router.navigate(['/accounting-centers']);
}
//  Nav Unit examine
nav_unit_perfomance(){ 
  this.popover.dismiss();
  this.router.navigate(['/setcontext']);
}
//  Nav User Manager
nav_usermanager(){ 
  this.popover.dismiss();
  this.router.navigate(['/usermanager']);
}

    logoutUser(){
      this.ClosePopover();
      this.authService.logout();
    }
    menu_nav(route){ 
      this.ClosePopover();
      let rout:string=route
      this.router.navigate([rout]);
      }
}
